module.exports = __webpack_public_path__ + "img/logo-bangkok-lotteries.23d47930.png";